<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [phoneNumber]="phoneNumber"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <!-- Introduction Section -->
  <div class="content-section">
    <div class="intro-card">
      <h2>Assurance Homme-Clé</h2>
      <p class="intro-text">
        Le contrat d'<strong>assurance Homme-Clé</strong> permet d'assurer la pérennité de votre entreprise en cas de disparition ou d'indisponibilité de l'homme-clé. A ce titre, et tant que protection financière, il est considéré comme faisant partie des <strong>Assurance Prévoyance Professionnelle</strong>.
      </p>
      <p class="partenaires-text">
        Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est listé ci-après : <strong>GENERALI, AXA SPVIE, APRIL, CREDIT MUTUEL, METLIFE, AFI-ESCA, BNP CARDIF…</strong>
      </p>
    </div>
  </div>

  <!-- Qu'est-ce qu'un Homme Clé Section -->
  <div class="content-section">
    <div class="definition-block">
      <h2><i class="fas fa-user-tie"></i> QU'EST-CE QU'UN HOMME-CLEF :</h2>
      <p>
        Un « homme-clé » est une personne qui a un rôle économique déterminant dans l'entreprise et dont la fonction, la compétence, la responsabilité, la notoriété contribue de manière décisive au fonctionnement de l'entreprise. Il peut s'agir du dirigeant, mais également de tout autre collaborateur dont les fonctions managériales, commerciales, techniques, joue un rôle déterminant dans l'activité de la société.
      </p>
      <p><strong>Exemples :</strong></p>
      <ul class="exemples-list">
        <li><i class="fas fa-check"></i> Le dirigeant ou un de ses adjoints,</li>
        <li><i class="fas fa-check"></i> Le commercial,</li>
        <li><i class="fas fa-check"></i> Le chef d'atelier,</li>
        <li><i class="fas fa-check"></i> Un collaborateur en mission sur un projet informatique, financier, marketing, qualité et tout autre projet de haute importance pour l'entreprise,</li>
        <li><i class="fas fa-check"></i> Ou une personne ayant un savoir-faire très spécifique : un "nez" chez un parfumeur, un chercheur spécialisé… .</li>
      </ul>
      <p class="highlight-text">
        L'homme-clé est une personne, appartenant aux effectifs de l'entreprise.
      </p>
      <p>
        Aujourd'hui, les PME/PMI ont de nombreuses solutions pour faire face aux pertes financières liées aux défaillances des outils de production ou des instruments de gestion. Cette démarche fait partie des préoccupations courantes du chef d'entreprise. Mais la survie d'une entreprise tient autant à l'appareil de production qu'à ses hommes.
      </p>
    </div>
  </div>

  <!-- Risques Section -->
  <div class="content-section">
    <div class="risques-block">
      <h3><i class="fas fa-exclamation-triangle"></i> Que faire si, demain, l'homme sur lequel repose une part importante du chiffre d'affaires de l'entreprise vient à disparaître ?</h3>
      <p>En effet, <span class="highlight-purple">25%</span> des entreprises font faillite la première année consécutivement à la perte d'un homme-clé, et <span class="highlight-purple">50%</span>dans les <span class="highlight-purple">5 ans</span>.</p>
      
      <h4>Les difficultés s'enchaînent généralement après la disparition de l'homme-clef :</h4>
      <ul class="difficultes-list">
        <li><i class="fas fa-times-circle"></i> Une baisse de qualité dans la production,</li>
        <li><i class="fas fa-times-circle"></i> Le ralentissement des commandes,</li>
        <li><i class="fas fa-times-circle"></i> Un déficit de satisfaction des clients et/ou une perte de leur confiance,</li>
        <li><i class="fas fa-times-circle"></i> Le désengagement des partenaires financiers,</li>
        <li><i class="fas fa-times-circle"></i> Un redressement judiciaire ou une cessation définitive d'activité… .</li>
      </ul>
    </div>
  </div>

  <!-- Solution Section -->
  <div class="content-section">
    <div class="solution-block">
      <h2><i class="fas fa-lightbulb"></i> QU'APPORTE LA SOLUTION HOMME-CLEF :</h2>
      <p>
        Pour pérenniser l'activité de l'entreprise, il est possible de s'assurer contre le risque de baisse de chiffre d'affaires induit par le décès ou l'invalidité d'un ou plusieurs collaborateurs-clés.
      </p>
      <p>
        La garantie "Homme-clé" couvre l'éventuel décès consécutif à un accident ou une maladie, mais également la perte totale et irréversible d'autonomie (versement d'un capital dans les deux cas).
      </p>
      
      <div class="options-box">
        <h4>D'autres options peuvent venir se greffer comme la couverture de l'invalidité permanente totale IPT (versement d'un capital) ou encore l'incapacité temporaire totale de travail ITT (versement d'indemnités journalières).</h4>
      </div>

      <div class="atouts-section">
        <h3>ATOUTS :</h3>
        <ol class="atouts-list">
          <li>Souscrire un contrat "Homme-clé" permet à l'entreprise de disposer rapidement de trésorerie pour continuer son activité,</li>
          <li>Cela représente une sécurité réelle pour l'entreprise et pour ses tiers (salariés, actionnaires, fournisseurs, clients, partenaires financiers) qui ont ainsi la certitude que l'entreprise pourra organiser la poursuite de son activité et faire face à ses engagements et charges fixes (paiement des salaires, règlement des fournitures, livraison des produits et services, remboursement crédit…). L'image de l'entreprise sera donc sauvegardée auprès des partenaires et clients grâce à l'aide financière apportée par la garantie,</li>
          <li>Une assurance "Homme clé" permet également à l'entreprise d'engager des frais supplémentaires pour recruter un remplaçant ou de gagner sa valeur de reprise en cas d'éventuelle transmission .</li>
        </ol>
      </div>
    </div>
  </div>

  <!-- Adherent Contrat -->
  <div class="content-section">
    <div class="adherent-block">
      <h3>ADHERENT CONTRAT :</h3>
      <p>L'entreprise.</p>
    </div>
  </div>

  <!-- Garanties -->
  <div class="content-section bg-light">
    <div class="garanties-block">
      <h2>GARANTIES :</h2>
      <ul class="garanties-list">
        <li><strong>Garantie de base :</strong> Versement du capital garanti en cas de Décès – PTIA toutes causes,</li>
        <li><strong>Garanties optionnelles :</strong></li>
      </ul>
      <ul class="garanties-optionnelles">
        <li>Versement d'une quote part du capital garanti en cas d'invalidité permanente totale de l'assuré. La quote-part est calculée en fonction du taux d'invalidité, généralement supérieure à <span class="highlight-purple">66 %</span>. Le versement du capital en cas d'IPT toutes causes met fin à l'Adhésion pour l'ensemble des garanties,</li>
        <li>Versement d'une indemnité journalière en cas d'incapacité temporaire totale de plus de <span class="highlight-purple">3 mois</span> (ITT). Cette indemnité journalière s'élève à <span class="highlight-purple">75 € / jour</span> minimum jusqu'à maximum <span class="highlight-purple">0,05 %</span> du capital décès dans la limite de <span class="highlight-purple">500 € / jour</span> pour les indemnités journalières versées à l'entreprise dans le cadre de l'incapacité temporaire totale ( à partir de <span class="highlight-purple">150 000 €</span> de capital minimum).</li>
      </ul>
    </div>
  </div>

  <!-- Tableau Comparatif -->
  <div class="content-section">
    <h2>ARCHITECTURE DU CONTRAT HOMME-CLEF :</h2>
    
    <div class="table-container">
      <table class="comparison-table">
        <thead>
          <tr>
            <th>Modules proposés</th>
            <th>Module Homme-Clé</th>
            <th>Module Temporaires Individuelles</th>
            <th>Module Associés</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="row-header"></td>
            <td>Versement d'un capital à l'entreprise en cas de décès ou de perte totale et irréversible d'autonomie ou d'invalidité permanente totale d'une personne essentielle au fonctionnement de l'entreprise afin de lui permettre de faire face à cette perte et de maintenir son développement.</td>
            <td>Versement d'un capital aux bénéficiaires désignés en cas de décès de l'assuré ou à l'assuré lui-même en cas de perte totale et irréversible d'autonomie ou d'invalidité permanente totale.</td>
            <td>Versement d'un capital aux associés survivants de l'entreprise en cas de décès ou de perte totale et irréversible d'autonomie ou d'invalidité permanente totale de l'un des associés assurés, afin de leur permettre de racheter les parts sociales de l 'assuré décédé ou invalide.</td>
          </tr>
          <tr>
            <td class="row-header">Personne(s)<br>couverte(s).</td>
            <td>L'homme-clé soit une personne jouant un rôle déterminant au sein de l'entreprise adhérente.</td>
            <td>Toute personne salariée de l'entreprise adhérente ou nommée désignée dans l'extrait K-bis de celle-ci ou tiers assuré en tant qu'homme-clé.</td>
            <td>Une personne ayant la qualité d'associé au sein de l'entreprise adhérente. Attention l'entreprise doit couvrir tous ses associés.</td>
          </tr>
          <tr>
            <td class="row-header">Bénéficiaire(s) du capital garanti.</td>
            <td>L'entreprise adhérente.</td>
            <td>Le ou les bénéficiaire(s) désigné(s) par l'assuré.</td>
            <td>L'associé ou les associés désignés survivants sous réserve qu'ils aient toujours la qualité d'associé à la date du décès/PTIA ou invalidité permanente totale.</td>
          </tr>
          <tr>
            <td class="row-header">Territorialité.</td>
            <td>En tant qu'adhérent : toute personne morale ayant son siège social en France métropolitaine hors Corse, membre de l'association souscriptrice En tant qu'assuré : toute personne physique dont la résidence principale se situe en France métropolitaine.</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td class="row-header">Cotisation.</td>
            <td>Payée par l'entreprise. Elles constituent pour l'entreprise des charges d'exploitation déductibles au titre de l'article 39 du CGI (frais généraux) pour les entreprises concernées des bénéfices industriels et commerciaux.</td>
            <td>Les cotisations : sont payées par l'entreprise et sont imposées comme un élément de rémunération du dirigeant ou de l'associé et doivent être réintégrées dans leur rémunération et soumises à l'imposition.</td>
            <td>Les cotisations sont payées par l'entreprise et sont considérées comme un élément de rémunération et devront être réintégrées dans leur rémunération et soumises à l'imposition.</td>
          </tr>
          <tr>
            <td class="row-header">Capital.</td>
            <td>Les prestations payées par l'assureur à l'entreprise entreront dans le bénéfice imposable de l'exercice de versement, dans les conditions de droit commun (article 38-2 du CGI). Il est néanmoins possible de les étaler par parts égales sur l'année de réalisation du sinistre et sur les quatre années suivantes.</td>
            <td>Le capital versé n'est en aucun cas soumis aux droits de succession.</td>
            <td>Le capital versé n'est en aucun cas soumis aux droits de succession.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="table-note">
      Le délai de règlement des prestations peut s'effectuer généralement sous <span class="highlight-purple">15 jours</span> une fois le dossier complet.
    </p>
    <p class="table-note">
      En fonction du montant des capitaux souscrits, l'homme-clé doit fournir un questionnaire de santé, complété éventuellement par un rapport médical et des examens des complémentaires. Un questionnaire financier peut également être demandé selon les montants des capitaux garantis.
    </p>
  </div>

  <!-- Comment évaluer le montant -->
  <div class="content-section">
    <div class="evaluation-block">
      <h2><i class="fas fa-calculator"></i> Comment évaluer le montant de la perte financière que peut représenter l'absence de l'homme-clé pour votre entreprise ?</h2>
      <p>Le niveau de la garantie doit être proportionnel par rapport à la contribution de l'homme clé. Pour fixer le montant de la perte financière, deux possibilités :</p>
      
      <h3><i class="fas fa-arrow-right"></i> Le calcul de la perte de marge brute :</h3>

      <div class="calcul-details">
        <p>Marge brute moyenne de votre entreprise : <span class="highlight-purple">500 000 €</span>.</p>
        <p>Progression annuelle moyenne constatée : <span class="highlight-purple">5 %</span>.</p>
        <p>Masse salariale : <span class="highlight-purple">300 000 €</span>.</p>
        <p>Rémunération de l'homme clé : <span class="highlight-purple">75 000 €</span>.</p>
        <p>Frais optionnels complémentaires (pour recrutement, conseil extérieur, formation) aboutissent à <span class="highlight-purple">20 %</span> de la rémunération.</p>
        <p>Impôt sur les Sociétés (IS) : <span class="highlight-purple">33,33 %</span>.</p>
        
        <div class="formule-box">
          <h4>Formule :</h4>
          <p><strong>(Marge brute moyenne x progression) x [(rémunération de l'homme clé/masse salariale totale) + frais supplémentaires] / (1-IS) :</strong></p>
          <p>=> (<span class="highlight-purple">500 000 x 1,05</span>) x [(<span class="highlight-purple">75 000 / 300 000</span> ) x <span class="highlight-purple">1,20</span>] / <span class="highlight-purple">0,67</span> = <span class="highlight-purple">235 000 €</span>.</p>
        </div>
        
        <h3>Le capital forfaitaire :</h3>
        <p>Il est également possible de fixer un montant de capital forfaitaire : Entre <span class="highlight-purple">10 000€</span> et <span class="highlight-purple">1000 000€</span>.</p>
      </div>
    </div>
  </div>

  <!-- Choix des Options -->
  <div class="content-section">
    <div class="options-block">
      <h3><i class="fas fa-cog"></i> Le choix des options :</h3>
      <p>Il est possible de cumuler le montant du capital versé à l'entreprise si il a été choisi l'option IPT.</p>
      
      <p>Enfin le choix de l'option de l'ITT n'est possible que s'il a été souscrit un capital décès / PTIA > <span class="highlight-purple">150 000 euros</span>.</p>
      <p>Le versement des IJ comprend généralement une franchise de <span class="highlight-purple">90 jours</span> .</p>
      
      <p>Au-delà d'<span class="highlight-purple">1 000 000€</span>, une étude sur-mesure sera effectuée par les services de l'assureur.</p>
      <p>Le tarif est réduit si l'homme clef n'est pas fumeur.</p>
      
      <p>La garantie décès s'arrête au <span class="highlight-purple">65e anniversaire</span> de l'assuré, la garantie PTIA à son <span class="highlight-purple">60e anniversaire</span>. Mais cela dépend de l'assureur.</p>
      
      <p>En ce qui concerne l'ITT, les IJ sont nées, avec un minimum de <span class="highlight-purple">75 €</span> par jour et un maximum de <span class="highlight-purple">500€</span> par jour. Les prestations sont fournies jusqu'à la reprise du travail, dans la limite de <span class="highlight-purple">365 jours</span> d'ITT, franchise incluse.</p>
    </div>
  </div>

</app-page-layout>
